import { formatMaybeDateString } from "../charts/utils";
import "./styles.scss";
import { get } from "lodash";
import { Surface, Rectangle } from "recharts";

export const CustomTooltip = ({
  active,
  payload,
  label,
  formatter = (v) => v,
}) => {
  if (active) {
    const normalizedLabel = formatMaybeDateString(label);
    return (
      <div className="chart__custom-tooltip">
        <div className="chart__custom-tooltip-label">{normalizedLabel}</div>
        {payload.map((p) => {
          const payloadColor = get(p, ["payload", "fill"], get(p, ["fill"]));
          return (
            <p
              key={get(p, ["name"])}
              style={{
                color: payloadColor,
              }}
            >
              <Surface
                width={10}
                height={10}
                style={{
                  display: "inline-block",
                  verticalAlign: "middle",
                  marginRight: 2,
                  opacity: p.fillOpacity,
                }}
              >
                <Rectangle
                  width={10}
                  height={10}
                  radius={2}
                  fill={payloadColor}
                />
              </Surface>
              <span style={{ fontWeight: "bold" }}>
                {`${get(p, ["name"])}:  ${formatter(get(p, ["value"]))}`}
              </span>
            </p>
          );
        })}
      </div>
    );
  }
  return null;
};
